import React, { useState, useEffect, useRef } from "react";
import "./PdfViewer.css";

const base64ToBlobUrl = (base64) => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: "application/pdf" });
  return URL.createObjectURL(blob);
};

const PdfPopup = ({ base64Pdf, onConsent }) => {
  const [pdfUrl, setPdfUrl] = useState("");
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const pdfViewerRef = useRef(null);

  useEffect(() => {
    if (base64Pdf) {
      const url = base64ToBlobUrl(base64Pdf);
      setPdfUrl(url);

      return () => {
        URL.revokeObjectURL(url); // Clean up blob URL when component unmounts
      };
    }
  }, [base64Pdf]);

  useEffect(() => {
    const handleScroll = () => {
      if (pdfViewerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = pdfViewerRef.current;
        setIsScrolledToBottom(scrollTop + clientHeight >= scrollHeight - 10);
      }
    };

    const viewer = pdfViewerRef.current;
    if (viewer) viewer.addEventListener("scroll", handleScroll);

    return () => {
      if (viewer) viewer.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="popup">
      <div className="pdf-container" ref={pdfViewerRef}>
        {pdfUrl ? (
          <iframe src={pdfUrl} width="100%" height="600px" title="Policy PDF"></iframe>
        ) : (
          <p>Loading PDF...</p>
        )}
      </div>

      {isScrolledToBottom && (
        <div className="consent-section">
          <label>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            I/We hereby declare that the Customer Information Sheet has been
            duly received and thoroughly reviewed. I/We confirm understanding
            and noting the details contained therein.
          </label>
          <div className="button-container">
            <button
              className="cancel-button"
              onClick={() => onConsent("no")} // Redirects if "No" is clicked
            >
              Cancel
            </button>
            <button
              className={`submit-button ${isChecked ? "enabled" : "disabled"}`}
              onClick={() => isChecked && onConsent("yes")} // Calls `onConsent("yes")` if checked
              disabled={!isChecked}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PdfPopup;
